import React, { useEffect, useRef, useState } from 'react'
import Dropdown from '../shared/Dropdown';
import useClickOutside from '../../hooks/useClickOutside';
import { Trans } from 'react-i18next';


export const timeFrameOptions = [
  { id: 'hour', value: 3600, label: "Hour", i18nKey: "dcaTimeFrame.hour" },
  { id: 'day', value: 86400, label: "Day", i18nKey: "dcaTimeFrame.day" },
  { id: 'week', value: 604800, label: "Week", i18nKey: "dcaTimeFrame.week" },
  { id: 'month',value: 2629746, label: "Month", i18nKey: "dcaTimeFrame.month" } // 30.4 days (365/12)
];

export default function DcaTimeFrame({
  value,
  onChange
}: {
  value: number;
  onChange: (value: number) => void;
}) {

  const [isOpened, setIsOpened] = useState(false);
  const selectedOption = timeFrameOptions.find(option => option.value === value);
  const ref = useRef<any>(null);

  useClickOutside(ref, () => {
    setIsOpened(false);
  });

  useEffect(() => {
    if (!value) {
      onChange(timeFrameOptions[0].value);
    }
  }, [value]);

  return (
    <Dropdown
      onClick={() => !isOpened && setIsOpened(!isOpened)}
      size="sm"
      className={`relative !bg-grey-600 min-w-[80px] lg:min-w-[120px] ${isOpened && `pointer-events-none`}`}
    >
      <div className="text-body3 text-grey-100">
        <Trans i18nKey={selectedOption?.i18nKey}>{selectedOption?.label}</Trans>
      </div>
      <div
        ref={ref as any}
        className={`absolute !pointer-events-auto !w-full bg-grey-600 rounded-xl top-0 left-1/2 shadow-[0_0_10px_#00000066] overflow-hidden -translate-x-1/2 -translate-y-[100%] transition-all pointer-events-none max-h-0 ${isOpened && `max-h-[200px] pointer-events-auto`}`}
        onClick={(e) => e.stopPropagation()}
      >
        {timeFrameOptions.map(option => (
          <div
            key={option.value}
            className={`text-body3 text-grey-100 py-2 hover:bg-grey-400 cursor-pointer ${option.value === value && `!bg-grey-400`}`}
            onClick={() => {
              onChange(option.value);
              setIsOpened(false);
            }}
          >
            <Trans i18nKey={option.i18nKey}>{option.label}</Trans>
          </div>
        ))}
      </div>
    </Dropdown>
  )
}
